<h2 mat-dialog-title>
  @if (isVoice) {
    {{ 'AI_ASSISTANT.TESTING.UPLOAD_MODAL.TITLE_VOICE' | translate }}
  } @else {
    {{ 'AI_ASSISTANT.TESTING.UPLOAD_MODAL.TITLE_CHAT' | translate }}
  }
</h2>

<mat-dialog-content>
  <glxy-form-field>
    <glxy-uploader #glxyUploader [maxFiles]="1" [accept]="'.json'" (fileUploaded)="onFileSelected($event)" />
    <glxy-uploader-list [files]="(glxyUploader.filesChanged | async) || []" />

    @if (testCases.length > 0) {
      <h3>{{ 'AI_ASSISTANT.TESTING.UPLOAD_MODAL.CASES_FOUND' | translate: { count: testCases.length } }}</h3>
    }
    @if (errors.length > 0) {
      <h3>{{ 'AI_ASSISTANT.TESTING.UPLOAD_MODAL.ERRORS_FOUND' | translate: { count: errors.length } }}</h3>
    }
    @for (error of errors; track error) {
      <glxy-error
        >{{ 'AI_ASSISTANT.TESTING.UPLOAD_MODAL.ERROR_IN_CASE' | translate: { index: error.rowIndex + 1 } }} -
        {{ error.message }}</glxy-error
      >
    }
  </glxy-form-field>

  <glxy-form-field>
    <mat-checkbox [(ngModel)]="removeExisting">{{
      'AI_ASSISTANT.TESTING.UPLOAD_MODAL.REPLACE_EXISTING' | translate
    }}</mat-checkbox>
  </glxy-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="downloadTemplate()" class="left-action">
    {{ 'AI_ASSISTANT.TESTING.DOWNLOAD_TEMPLATE' | translate }}
  </button>
  <button mat-stroked-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
  <button mat-flat-button color="primary" (click)="save()">{{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}</button>
</mat-dialog-actions>
